module.exports = __webpack_public_path__ + "static/media/ChangeLangEnFr.3667d922.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ChangeLangEnFr.png
// module id = 616
// module chunks = 0